/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H217483 on 1/3/2019.
 */

import React from 'react'
import {injectIntl} from 'react-intl';
import {Tab} from '@scuf/common';
import Loader from '../../common/Loader'
import {withRouter} from "react-router";
import FaultCards from './FaultCards'
import {CURRENT_FAULT_STATES, FAULT_HISTORY_SORT, FAULT_SORT, FAULT_STATES} from "../common/FaultsConst";
import * as Faults from "../../api/Faults";
import * as Airtime from "../../api/Airtime"
import queryString from "query-string";
import PredictiveIndicators from "./PredictiveIndicators"
import {userHasActivity} from "../../security/SecurityUtils";
import connect from "react-redux/es/connect/connect";
import {ACTIVITY_TYPES} from "../../security/SecurityConst";
import {bindActionCreators} from "redux";
import * as SecurityActions from "../../security/SecurityActions";
import {verifyAirtimeException} from "../../utils/Helpers";
import {showNotification} from "../../common/ToastNotification";
import {formatMessage} from "../../common/LocaleHelper";

class FaultsList extends React.Component {

    constructor(props) {
        super(props)

        const query = queryString.parse(this.props.location.search)
        const tab = query.tab

        let tabIndex
        if (tab === 'history') {
            tabIndex = 1
        } else if (tab === 'predictiveIndicators') {
            tabIndex = 2
        } else {
            tabIndex = 0 // Default tab shows current faults list
        }

        this.state = {
            tabIndex: tabIndex,
            filter: {
                currentSort: FAULT_SORT.NAME,
                historySort: FAULT_HISTORY_SORT.HISTORY_CLOSED,
                states: CURRENT_FAULT_STATES,
                search: '',
                start: 0,
                limit: 12,
            },
            faults: [],
            allFaultsCount: 0,
            loading: false,
            expandedRows: [],
            apiPoint: userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY) ? Airtime : Faults,
        }

        this.searchChanged = this.searchChanged.bind(this)
        this.currentSortChanged = this.currentSortChanged.bind(this)
        this.historySortChanged = this.historySortChanged.bind(this)
        this.stateChanged = this.stateChanged.bind(this)
    }

    componentDidMount() {
        this.fetchFaults()
        const notificationText = this.props.location != null && this.props.location.state != null ? this.props.location.state.notificationText : null;

        if (notificationText != null) {
            showNotification({
                translationPropertyKey: notificationText,
                severity: "information",
            })
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.assetId !== prevProps.assetId) {
            this.fetchFaults()
        }
    }

    changeTab(index) {
        const {history, userProfile} = this.props

        this.setState({
            ...this.state,
            tabIndex: index,
            filter: {
                ...this.state.filter,
                // sort: index === 0 ? FAULT_SORT.NAME : FAULT_HISTORY_SORT.HISTORY_CLOSED
            },
        }, this.fetchFaults)

        switch (index) {
            case 0:
                history.push({search: '?tab=current'})
                break;
            case 1:
                history.push({search: '?tab=history'})
                break;
            case 2:
                userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES) ?
                    history.push({search: '?tab=current'})
                    :
                    history.push({search: '?tab=predictiveIndicators'})
                break;
            default:
                history.push({search: '?tab=current'})
                break;
        }
    }

    searchChanged(search) {
        this.setState({
            ...this.state,
            filter: {
                ...this.state.filter,
                search: search,
            },
        }, this.fetchFaults)
    }

    currentSortChanged(sort) {
        if (sort !== this.state.filter.currentSort) {
            this.setState({
                ...this.state,
                filter: {
                    ...this.state.filter,
                    currentSort: sort,

                },
            }, this.fetchFaults)
        }
    }

    historySortChanged(sort) {
        if (sort !== this.state.filter.historySort) {
            this.setState({
                ...this.state,
                filter: {
                    ...this.state.filter,
                    historySort: sort,

                },
            }, this.fetchFaults)
        }
    }

    stateChanged(selectedStates) {
        this.setState({
            ...this.state,
            filter: {
                ...this.state.filter,
                states: selectedStates,
            },
        }, this.fetchFaults)
    }

    fetchFaults() {
        let states = this.state.filter.states
        let sort = this.state.filter.currentSort

        if (this.state.tabIndex === 1) {
            states = [FAULT_STATES.CLOSED_RESOLVED, FAULT_STATES.CLOSED_DUE_TO_LDI_IMPORT, FAULT_STATES.CLOSED_DUE_TO_INACTIVITY]
            sort = this.state.filter.historySort
        }
        const filterObj = {
            search: this.state.filter.search,
            start: this.state.filter.start,
            limit: this.state.filter.limit,
            sort: sort,
        }
        this.setState({loading: true})
        if (this.props.assetId) {
            this.state.apiPoint.fetchAssetFaults(this.props.assetId, states, filterObj)
                .then((pageableResponse) => this.setStateFaultsResponse(pageableResponse))
                .catch(ex => {
                    verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
                })
        } else {
            this.state.apiPoint.fetchFaults(states, filterObj)
                .then((pageableResponse) => this.setStateFaultsResponse(pageableResponse))
                .catch(ex => {
                    verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
                })
        }
    }

    setStateFaultsResponse = (pageableResponse) => {
        this.setState({
            faults: pageableResponse.results,
            allFaultsCount: pageableResponse.totalCount,
            loading: false,
        })
    }

    loadList = (start, limit) => {
        const newFilter = this.state.filter
        newFilter.limit = limit
        newFilter.start = start - 1
        this.setState({
            filter: newFilter,
        })
        this.fetchFaults()
    }


    render() {
        const {intl, userProfile} = this.props
        const {allFaultsCount, faults} = this.state;
        let tabs

        // When asset id is unknown (on Faults page) don't show predictive indicator tab
        if (this.props.assetId != null && !userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES)) {
            tabs =
                <Tab onTabChange={(activeIndex) => (this.changeTab(activeIndex))} renderActiveOnly={true}
                     defaultActiveIndex={this.state.tabIndex}>
                    <Tab.Pane title={intl.formatMessage({id: "faults.tab.current"})}>
                        <FaultCards faults={faults}
                                    totalCount={allFaultsCount}
                                    start={this.state.filter.start}
                                    limit={this.state.filter.limit}
                                    parentLoadListMethod={this.loadList}
                                    {...this.state.filter} sort={this.state.filter.currentSort}
                                    searchChanged={this.searchChanged} sortOptions={FAULT_SORT}
                                    sortChanged={this.currentSortChanged} stateChanged={this.stateChanged}
                                    loading={this.state.loading}/>
                    </Tab.Pane>
                    <Tab.Pane title={intl.formatMessage({id: "faults.tab.history"})}>
                        <FaultCards faults={faults}
                                    totalCount={allFaultsCount}
                                    start={this.state.filter.start}
                                    limit={this.state.filter.limit}
                                    parentLoadListMethod={this.loadList}
                                    {...this.state.filter} sort={this.state.filter.historySort}
                                    searchChanged={this.searchChanged} sortOptions={FAULT_HISTORY_SORT}
                                    sortChanged={this.historySortChanged} loading={this.state.loading}/>
                    </Tab.Pane>
                    <Tab.Pane title={intl.formatMessage({id: "faults.tab.predictiveIndicators"})}>
                        <PredictiveIndicators assetId={this.props.assetId}/>
                    </Tab.Pane>
                </Tab>
        } else {
            tabs =
                <Tab onTabChange={(activeIndex) => (this.changeTab(activeIndex))} renderActiveOnly={true}
                     defaultActiveIndex={this.state.tabIndex}>
                    <Tab.Pane title={intl.formatMessage({id: "faults.tab.current"})}>
                        <FaultCards faults={faults}
                                    totalCount={allFaultsCount}
                                    start={this.state.filter.start}
                                    limit={this.state.filter.limit}
                                    parentLoadListMethod={this.loadList}
                                    {...this.state.filter} sort={this.state.filter.currentSort}
                                    searchChanged={this.searchChanged} sortOptions={FAULT_SORT}
                                    sortChanged={this.currentSortChanged} stateChanged={this.stateChanged}
                                    loading={this.state.loading}/>
                    </Tab.Pane>
                    <Tab.Pane title={intl.formatMessage({id: "faults.tab.history"})}>
                        <FaultCards faults={faults}
                                    totalCount={allFaultsCount}
                                    start={this.state.filter.start}
                                    limit={this.state.filter.limit}
                                    parentLoadListMethod={this.loadList}
                                    {...this.state.filter} sort={this.state.filter.historySort}
                                    searchChanged={this.searchChanged} sortOptions={FAULT_HISTORY_SORT}
                                    sortChanged={this.historySortChanged} loading={this.state.loading}/>
                    </Tab.Pane>
                </Tab>
        }
        return (
            <div id="faults-list" className={this.props.assetId ? 'asset-faults' : ''}>
                <Loader loading={this.state.loading}/>
                {tabs}
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        userProfile: state.security.userProfile,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        SecurityActions: bindActionCreators(SecurityActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(FaultsList)))
